interface VisuallyHiddenTableProps {
  caption: string
  rows: Array<{ label: string; value: string | number }>
}

const VisuallyHiddenTable = ({ caption, rows }: VisuallyHiddenTableProps) => {
  if (rows.length === 0) {
    return null
  }

  return (
    <table className="sr-only">
      <caption>{caption}</caption>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <th scope="row">{row.label}</th>
            <td>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default VisuallyHiddenTable
